define.alias("shared/components/shared/appstore-links", "calendar/components/shared/appstore-links");